import { TrendingUp, Users } from "lucide-react";
import React from "react";

const LeftSection = () => {
  return (
    <section className="flex flex-col py-20 space-y-8">
      <div className="space-y-4">
        <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
          Reconnect. Share. Grow.
        </h1>

        <p className="text-lg text-gray-600 max-w-md">
          Reconnect with old colleagues and unlock new opportunities.
        </p>
      </div>

      <div className="space-y-4">
        <div className="flex items-start space-x-3 p-3 rounded-lg bg-white border">
          <div className="w-10 h-10 bg-orange-50 rounded flex items-center justify-center flex-shrink-0 mt-1">
            <Users className="w-5 h-5 text-orange-600" />
          </div>
          <div>
            <h3 className="font-semibold text-gray-900">Stay in touch</h3>
            <p className="text-gray-600 text-sm">
              Reconnect with teammates from past jobs.
            </p>
          </div>
        </div>

        <div className="flex items-start space-x-3 p-3 rounded-lg bg-white border">
          <div className="w-10 h-10 bg-orange-50 rounded flex items-center justify-center flex-shrink-0 mt-1">
            <TrendingUp className="w-5 h-5 text-orange-600" />
          </div>
          <div>
            <h3 className="font-semibold text-gray-900">Share knowledge</h3>
            <p className="text-gray-600 text-sm">
              Help each other grow careers.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LeftSection;
